<p [style]="{padding:'20px',background:'#f3d984',borderRadius:'6px'}">Ziyaretçi Kullanıcı Olarak Giriş Yaptınız için Yeni Kayıt,Düzenleme ve Silme Gibi İşlemleri Yapamazsınız.</p>
